import { render, staticRenderFns } from "./Coprifili.vue?vue&type=template&id=794db2da&"
import script from "./Coprifili.vue?vue&type=script&lang=js&"
export * from "./Coprifili.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports